<template>
  <v-dialog v-model="visible" max-width="500">
    <Box title="انتخاب قالب">
      <div class="pa-2">
        <v-card
          class="my-2"
          :disabled="$vuetify.theme.themes.name === theme.name"
          @click="setTheme(theme)"
          hover
          outlined
          v-for="(theme, index) in themes"
          :key="index"
        >
          <div class="d-flex pa-3">
            <v-card
              width="25"
              height="25"
              :color="theme.light['primary']"
            ></v-card>
            <span class="font-weight-bold px-2">{{ theme.name }}</span>
            <v-icon v-if="$vuetify.theme.themes.name === theme.name"
              >mdi-check</v-icon
            >
          </div>
        </v-card>
      </div>
    </Box>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      themes: [
        {
          name: "قالب اصلی",
          colorNumber:"1",

          light: {
            primary: "#272161",
            accent: "#fcc401",
            secondary: "#21dc79",
            success: "#9cf4dc",
            info: "#f34fc6",
            warning: "#FB8C00",
            error: "#ffb4b4",
          },
          dark: {
            primary: "#646172",
            accent: "#fcc401",
            secondary: "#26ff8c",
            success: "#9cf4dc",
            info: "#ff53d0",
            warning: "#ff8e00",
            error: "#ffb4b4",
          },
        },
        {
          name: "قالب نارنجی",
          colorNumber:"2",
          dark: {
            primary: "#E65100",
            accent: "#fcc401",
            secondary: "#689F38",
            success: "#4CAF50",
            info: "#6156d8",
            warning: "#1565C0",
            error: "#FF7043",
          },
          light: {
            primary: "#E65100",
            accent: "#fcc401",
            secondary: "#92de4e",
            success: "#6dff74",
            info: "#7365ff",
            warning: "#2e8ac0",
            error: "#ff5e3c",
          },
        },
        {
          name: "قالب سبز",
          colorNumber:"3",

          dark: {
            primary: "#689F38",
            accent: "#7CB342",
            secondary: "#689F38",
            success: "#4CAF50",
            info: "#f34fc6",
            warning: "#FB8C00",
            error: "#ffb4b4",
            textcolor:"#ffffff",
            
          },
          light: {
            primary: "#689F38",
            accent: "#a1e754",
            secondary: "#26ff8c",
            success: "#9cf4dc",
            info: "#ff53d0",
            warning: "#ff8e00",
            error: "#ffb4b4",
            textcolor:"#000000",
          },
        },
        {
          name: "قالب آبی",
          colorNumber:"4",
          dark: {
            primary: "#2380ad",
            accent: "#7CB342",
            secondary: "#689F38",
            success: "#4CAF50",
            info: "#f34fc6",
            warning: "#FB8C00",
            error: "#ffb4b4",
            textcolor:"#ffffff",
            
          },
          light: {
            primary: "#2380ad",
            accent: "#a1e754",
            secondary: "#26ff8c",
            success: "#9cf4dc",
            info: "#ff53d0",
            warning: "#ff8e00",
            error: "#ffb4b4",
            textcolor:"#000000",
          },
        },
      ],
    };
  },

  methods: {
    show() {
      this.visible = true;
    },
    setTheme(theme) {
      //debugger
      const name = theme.name;
      const colorNumber = theme.colorNumber;
      const dark = theme.dark;
      const light = theme.light;

      //this.$vuetify.theme.themes.dark = dark;
      //this.$vuetify.theme.themes.light = light;
      // set themes
      Object.keys(dark).forEach((i) => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach((i) => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });
      //debugger;
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name;
      this.$vuetify.theme.themes.colorNumber = colorNumber;
      this.visible = false;
      this.$emit("change", name);
    },
  },
};
</script>

<style>
</style>